import { post,postForm,get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getDomesticBankList = record => post(url.DOMESTICBANK_DEFINITIONS,record)
export const getPayFacCommissionBankListByUserName = userName => get(url.DOMESTICBANK_DEFINITIONS_GET_USERNAME+"?userName="+ userName)